<template>
    <div class="story-maker-sticker story-maker-sticker-question" :class="{edit: isSelected}" @click="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')" @click="stickerInstance.nextColor">
        <div class="sticker sticker-question" 
            :style="{ 
                backgroundColor: stickerInstance.data.color
            }"
            :class="[`color-${stickerInstance.data.color.slice(1).toUpperCase()}`]"
        >

            <div class="container-picture-image">
                <div 
                    class="picture-page"
                    :style="{ 
                        borderColor: stickerInstance.data.color
                    }"
                >
                    <img :src="$attrs.pageSelected && $attrs.pageSelected.avatar ? $attrs.pageSelected.avatar : 'img/avatar.jpg'">
                </div>
            </div>
            <div 
                class="question-header"
            >
                    <textarea cols="20" rows="2" wrap="hard" maxlength="100" :placeholder="$t('dash.post-creator.story.question-placeholder')" v-model="stickerInstance.data.question" :readonly="!isSelected"></textarea>
            </div>
            <div class="fake-input">
                    <p v-if="isSelected">{{ $t('dash.post-creator.story.question-people-answer') }}</p>
                    <p v-else>{{ $t('dash.post-creator.story.question-enter-something') }}</p>
            </div>
            
        </div>
        
    </div>
</template>

<script>
    export default {
        props: {
            id: Number | String,
            isSelected: Boolean,
            stickerInstance: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
            }
        },

        mounted () {
        },

        methods: {
            finish(event) {
                if (this.isSelected && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                    this.$emit('unselect')
                    if (!this.stickerInstance.data.question.trim()) {
                       this.$emit('deleteSticker')
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>
<!-- https://vuejs.org/guide/built-ins/transition-group -->